<template>
    <div class="defaultULReview">
        <div class="defaultReview-header d-flex flex-between align-items-start">
            <div class="d-flex">
                <div class="header__icon-container">
                    <img src="/static/images/icons/info_icon_reg_details.svg" class="mr-5"/>
                </div>
                <div class="header__description-container ml-10">
                    <div class="m-0 product-details-title">{{$t('productDetails')}}</div>
                    <p>{{$t('productDetailsDescription')}}</p>
                </div>
            </div>
            <div class="d-flex" v-if="componentType.type==='view-record'">
                <button class="btn download-evidence" :disabled="!componentType.status" @click="downloadEvidence()"><img src="/static/images/icons/DownloadTemplate.svg" />{{ $t('consolidateEvidence') }}</button>
            </div>
        </div>
        <div class="form-separator"></div>
        <div class="defaultReview-content">
            <div class="defaultReview-content__container">
                <ul class="product--details">
                    <li v-for="product in productDetails" :key="product.id" class="product-entry d-flex flex-between"><div class="product-key"><span>{{ product.detailKey }}:</span></div><div class="product-value"><span v-if="product.detailValue" :title="product.detailValue">{{ product.detailValue }}</span><span v-else>-</span></div></li>
                </ul>
                <div class="form-separator"></div>
                <div class="defaultReview-footer d-flex justify-content-end" v-if="!viewDetails"><button class="btn emergo-btn emergo-cancel-button" @click="viewDetailsOperation">{{ $t('ViewDetails') }}</button></div>
                <div v-if="viewDetails">
                    <ul class="certificate--details">
                      <li v-for="certificate in newCertificateDetails" :key="certificate.id" class="certificate-entry d-flex flex-between"><div  class="certificate-key"><span>{{ certificate.detailKey }}:</span></div>
                     <div class="certificate-value"><span v-if="certificate.detailValue" :title="certificate.detailValue">{{ certificate.detailValue }}</span><span v-else>-</span></div></li>
                    </ul>
                <div class="form-separator"></div>
                <!-- <DefaultSearchWithTable :uploadBtn="uploadBtn" :registrationId="registrationId" :headerText="'Attachments (Optional)'" :tabNames="[{ id: 1, tabName: 'Test Reports' }, { id: 2, tabName: 'Product Certificates' }, { id: 3, tabName: 'Barcodes' }, { id: 4, tabName: 'Maintenance Documents' }]" :tableLabels="['File Name']" :filesArray="filesArray" class="searchTable"/> -->
                <DefaultSearchWithTable class="searchTable" :registrationId="registrationId" :headerText="'Attachments (Optional)'" :tabNames="attachmentTypeList" :tableLabels="['File Name']"
              :filesArray="fileArrayObject[attachmentTypeList[tableActiveTab - 1].tabName]" @tableTabChanged="tabChangedEmit" :activeTab="tableActiveTab" :key="attachmentTypeList[tableActiveTab - 1].tabName?attachmentTypeList[tableActiveTab - 1].tabName : 'sample'" :uploadBtn="false" :downloadBtn="downloadBtn"/>
                <div class="form-separator"></div>
                </div>
            </div>
        </div>
        <div class="defaultReview-footer d-flex justify-content-end" v-if="viewDetails">
            <button class="btn emergo-btn emergo-cancel-button" @click="viewDetailsOperation">{{ $t('hideDetails') }}</button>
        </div>
    </div>
</template>
<script>
import DefaultSearchWithTable from './DefaultSearchWithTable.vue';

export default {
  components: {
    DefaultSearchWithTable,
  },
  props: {
    productDetails: { // Array should be in the format of [{id: 1, detailKey: 'sample text', detailValue: 'sample Text'}]
      type: Array
    },
    certificateDetails: { // Array should be in the format of [{id: 1, detailKey: 'sample text', detailValue: 'sample Text'}]
      type: Array
    },
    filesArray: {
      type: Object
    },
    componentType: {
      type: Object
    },
    registrationId: {
      type: Number
    },
    isNewToMarket: {
      type: Boolean
    },
    uploadBtn: {
      type: Boolean
    },
    displayMaintenanceDocuments: {
      type: Boolean
    },
    downloadBtn: {
      type: Boolean
    },
    finalReview: {
      type: Boolean
    }
  },
  data() {
    return {
      viewDetails: false,
      attachmentTypeList: [{ id: 1, tabName: 'Test Reports' }, { id: 2, tabName: 'Product Certificates' }, { id: 3, tabName: 'Barcodes' }],
      fileArrayObject: {},
      tableActiveTab: 1,
      newCertificateDetails: []
    };
  },
  created() {
    this.fileArrayObject = this.filesArray;
    if (this.displayMaintenanceDocuments && this.displayMaintenanceDocuments.length) {
      this.attachmentTypeList.push({ id: 4, tabName: 'Maintenance Documents' });
    }
    this.newCertificateDetails = this.isNewToMarket || this.finalReview ? [] : this.certificateDetails;
    this.HideCertificateDetails();
  },
  methods: {
    HideCertificateDetails() {
      const details = [this.$t('certificationNumber'), this.$t('certificationURLOpt'), this.$t('managedBy'), this.$t('accreditedBy'), this.$t('registrationDate'), this.$t('dateOfIssue'), this.$t('maintenanceDate'), this.$t('nextMaintenanceDate'), this.$t('dateOfExpiration'), this.$t('alertDate')];
      this.certificateDetails.forEach((item) => {
        if (!details.includes(item.detailKey) && (this.isNewToMarket || this.finalReview)) {
          this.newCertificateDetails.push(item);
        }
      });
    },
    tabChangedEmit(e) {
      this.tableActiveTab = e;
    },
    downloadEvidence() {
      this.$emit('downloadEvidence');
    },
    viewDetailsOperation() {
      this.viewDetails = !this.viewDetails;
    }
  }
};
</script>
<style scoped>
.product-details-title {
  color: #3E3E3E;
  font-size: 24px;
  font-weight: 400;
  line-height: 34px
}

.defaultULReview {
    padding: 20px 16px;
    border: 1px solid #b3b3b3;
}

.download-evidence,
.download-evidence:hover
 {
    border: none;
    background: unset;
    color: #00518A;
}

.header__description-container h3 {
    line-height: 34px;
}

.header__description-container p {
    line-height: 26px;
    margin-bottom: 24px;
    color: #3E3E3E;
    font-size: 16px;
    font-weight: 400;
}
.product-entry,.certificate-entry {
    margin-bottom: 24px;
}
.product--details li .product-key,.certificate--details li .certificate-key{
    font-weight: 600;
}

.product-key,.product-value,.certificate-key,.certificate-value {
    width: 50%;
    color: #3E3E3E;
}

.product-key span,.certificate-key span {
    display: block;
}
.product--details, .certificate--details {
  margin-right: 7px;
}

.product-value span,.certificate-value span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.form-separator {
    border: 1px solid rgba(0, 0, 0, 0.12);
    margin-left: 36px;
    width: calc(100% - 45px);
    margin-bottom: 24px;
}

.searchTable {
    padding: 30px 50px;
}
</style>
